/**
 * Created by Ning Jiang on 2021-06-04.
 */

import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {TimelineLite, TweenLite} from "gsap";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {ElGordosRevengeGameAssets} from "../ElGordosRevengeGameAssets";
import {ElGordosRevenge} from "../ElGordosRevenge";
import {ElGordosRevengeLayers, Layers} from "./ElGordosRevengeLayers";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {EGRStackedWild} from "../symbol/EGRStackedWild";
import {ElGordosRevengeGameConfig} from "../ElGordosRevengeGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {ElGordosRevengeSound} from "../sound/ElGordosRevengeSound";

export class Multiplier extends PIXI.Container {

    private readonly _numberStyle:BitmapTextStyleOptions = {
        fontName : ElGordosRevengeGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
        fontSize : 30,
        tint : ElGordosRevengeGameConfig.MULTIPLIER_TEXT_TINT
        // tint : 0x6C7346 xNudge logo color
        // tint : 0xDFD2AA WXN bg color
    };

    private _emptyHolder:PIXI.Sprite;
    private _numberText:PIXI.BitmapText;
    private _effectContainer:PIXI.Container;
    // private _numberGlowText:PIXI.BitmapText;
    // private _effectContainer:PIXI.Container;
    // private _isSuper:boolean;

    // private _lastSoundIndex:number;
    // private _lastSoundTime:number;

    private _currentMultiplierOnReels:number[] = [0, 0, 0, 0, 0, 0];

    public get currentMultiplier():number {
        if(!this._currentMultiplierOnReels) {
            return 0;
        }
        return ArrayHelper.arraySum(this._currentMultiplierOnReels);
    }

    constructor() {
        super();

        this._emptyHolder = new PIXI.Sprite(ElGordosRevenge.assetLoader.getTextures("xNudgeLogo")[0]);
        this._emptyHolder.anchor.set(0.5);
        this._emptyHolder.scale.set(0.74);
        this._emptyHolder.position.set(2, 2);
        this.addChild(this._emptyHolder);

        this._effectContainer = new PIXI.Container();
        this.addChild(this._effectContainer);

        this._numberText = new PIXI.BitmapText("", this._numberStyle);
        (<PIXI.Point>this._numberText.anchor).set(0.5, 1.38);
        this._numberText.letterSpacing = -10;
        this._numberText.visible = false;
        this._numberText.y = 4;
        this.addChild(this._numberText);

        this.position.set(658, 114);
        ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this);

        if(ElGordosRevenge.model.isRestore) {
            ElGordosRevenge.model.parsedInitData.multiplierOnReels.forEach((m, reelId) => {
                if(m > 0) {
                    const w = <EGRStackedWild>ElGordosRevenge.reels[reelId].getSymbol(0);
                    if(!w.stack) {
                        throw new Error(`Multiplier.constructor() restore nudge multiplierOnReels error on reelId ${reelId}, symId:${0}`);
                    }
                    w.showMultiplier(m, false)
                }
                this.updateReelMultiplier(reelId, m, false);
            });
            this.updateTotalMultiplier(false);
        } else {
            this.resetReel(false);
        }
        // this.updateMultiplier(123456, false);
    }

    private updateSize(animate:boolean):void {
        const landscapeMaxWidth = 110;
        this._numberText.scale.set(1, 0.7);
        this._numberText.updateTransform();
        const targetScale = this._numberText.textWidth > landscapeMaxWidth ? MathHelper.roundToDecimals(landscapeMaxWidth / this._numberText.textWidth, 2) : 1;
        this._numberText.scale.set(targetScale, targetScale * 0.7);
        const tl = new TimelineLite();
        if(animate) {
            tl.add(() => {
                this._numberText.scale.set(targetScale * 1.2, targetScale * 1.2 * 0.7);
                this.playEffect();
            }, 0);
            // if(this._numberGlowText.visible) {
            //     tl.add([
            //         () => {this._numberGlowText.scale.set(1.2 * 0.44)},
            //         TweenLite.to(this._numberGlowText.scale, 0.3, {x : 0.44, y : 0.44})
            //     ]);
            // }
        }
        tl.add(TweenLite.to(this._numberText.scale, 0.3, {x : targetScale, y : targetScale * 0.7}));
    }

    private playEffect():void {
        let effect = new TimelineSprite(ElGordosRevenge.assetLoader.getTextures("animJpeg/explosion/explosion_"), 15);
        effect.blendMode = PIXI.BLEND_MODES.ADD;
        effect.anchor.set(0.5);
        effect.alpha = 0.6 + Math.random() * 0.2;
        effect.scale.set(0.6 + Math.random() * 0.4);
        effect.hide();
        effect.position.set(MathHelper.randomIntInRange(-15, 15), MathHelper.randomIntInRange(-15, 15))
        this._effectContainer.addChild(effect);
        const tl = new TimelineLite();
        tl.add(effect.getAnimationAutoShowHide());
        tl.add(() => {
            this._effectContainer.removeChild(effect);
            effect.destroy();
        });
    }

    public resetReel(playAni:boolean = true):void {
        // if(this.isSticky(DeadwoodRip.model.data.nextMode)) {
        //     return;
        // }
        const oldValue = this.currentMultiplier;
        this._currentMultiplierOnReels = [0, 0, 0, 0, 0, 0];
        this.updateTotalMultiplier(playAni && (oldValue != this.currentMultiplier), true);
    }

    public updateTotalMultiplier(playAni:boolean = true, reset:boolean = false):void {
        if(ElGordosRevenge.model.isRestore) {
            playAni = false;
        }
        const displayValue = this.currentMultiplier;
        this._numberText.text = `x${displayValue.toString()}`;
        if(displayValue > 0) {
            this._numberText.visible = true;
            // this._numberGlowText.visible = this._isSuper;
            this._emptyHolder.visible = false;
            this.updateSize(playAni);
            if(playAni && !reset) {
                ElGordosRevengeSound.playMultiplierUpSound();
            }
        } else {
            this._numberText.visible = false;
            // this._numberGlowText.visible = false;
            this._emptyHolder.visible = true;
        }
    }

    public updateReelMultiplier(reelId:number, multiplier:number, updateDisplay:boolean):void {
        const oldValue = this._currentMultiplierOnReels[reelId];
        if(oldValue != multiplier) {
            this._currentMultiplierOnReels[reelId] = multiplier;
            if(updateDisplay) {
                this.updateTotalMultiplier(true);
            }
        }
    }

    // public addMultiplier(value:number, log:string):void {
    //     // Logger.logDev(`MULTIPLIER: Adding multiplier from ${log}, old value ${this._currentMultiplier}, new value ${this._currentMultiplier + value}`);
    //     const endValue = this._currentMultiplier + value;
    //     // this.playAddEffects(endValue);
    //     this.updateMultiplier(endValue, true);
    // }

    // private playAddEffects(value:number):void {
    //     if(value < 5) {
    //         return;
    //     }
    //
    //     const now = Date.now();
    //     const soundIndex = this.getSoundIndex(value);
    //     if((now - this._lastSoundTime < 50) && soundIndex === this._lastSoundIndex) {
    //         return;
    //     }
    //
    //     this._lastSoundTime = now;
    //     this._lastSoundIndex = soundIndex;
    //     TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.MULTIPLIER[soundIndex]});
    //     const effect = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("multiplier"));
    //     effect.autoUpdate = true;
    //     this._effectContainer.addChild(effect);
    //     const tween = new SpineTween(effect, 0, "glow");
    //     tween.vars.onComplete = () => SpineHelper.destroySpine(effect);
    // }

    private getSoundIndex(value:number):number {
        if(value < 8) {
            return 0;
        }
        if(value < 11) {
            return 1;
        }
        if(value < 14) {
            return 2;
        }
        if(value < 17) {
            return 3;
        }
        return 4;
    }

    // private isSticky(nextMode:string):boolean {
    //     return nextMode === GameMode.FREESPIN || nextMode === DeadwoodRipGameMode.FREESPIN_SUPER;
    // }

    public verifyMultipliers():void {
        if(!NolimitConfig.isDevMode) {
            return;
        }

        const reelData = ElGordosRevenge.model.parsedGameData.multiplierOnReels.concat();
        this._currentMultiplierOnReels.forEach((reelMultiplier, reelId) => {
            if(reelMultiplier != reelData[reelId]) {
                debugger;
                throw new Error("Displaying Multiplier doesn't match server data.");
            }
        });
    }

    public initFS():void {
        // this.updateMultiplier(DeadwoodRip.model.currentParsedData.currentMultiplier, false);
    }

    public resetAfterFS():void {
        // if(ElGordosRevenge.model.parsedGameData.betWins.length === 0) {
        //     this.reset();
        // } else {
        //     this._numberText.visible = true;
        //     // this._numberGlowText.visible = false;
        // }
    }

    public setColor(color:number, isSuper:boolean):void {
        // this._isSuper = isSuper;
        this._numberText.tint = color;
    }

    public shake():void {
        const tl = new TimelineLite();
        tl.add(TweenLite.to(this.scale, 0.2, {x : 1.1, y : 1.1}));
        tl.add(TweenLite.to(this.scale, 0.1, {x : 1, y : 1}));
    }
}